import React, { useState, useEffect, useCallback , useRef} from "react";
import styles from "./style.module.css";
import  "../../../css/app.scss";
import TestimonialCard from "../../../themes/woa/TestimonialCard";
import TestimonialCardD2 from "../../../themes/woa/TestimonialCardD2";
import TestimonialCardD3 from "../../../themes/woa/TestimonialCardD3";


export default function TestimonialD1({ datapost  , settings}) {

 
  /* console.log(settings);
  console.log(datapost); */
  const [testimonials , setTestimonials] = useState(datapost);
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  // Create a new array with cloned items for infinite scrolling
  const cloneCount = settings.max_per_dot;// Number of items to clone at each end
  // console.log(cloneCount);
  const allTestimonials = [
    ...testimonials.slice(testimonials.length - cloneCount),
    ...testimonials,
    ...testimonials.slice(0, cloneCount),
  ]
 console.log(testimonials.length , "testimonials.length");
  const [currentIndex, setCurrentIndex] = useState(cloneCount) // Start at the first real item
  const [cardWidth, setCardWidth] = useState(0)
  const [cardMargin, setCardMargin] = useState(0)
  const [isTransitioning, setIsTransitioning] = useState(true)
  const [cardFlex, setCardFlex] = useState(31.333)
  const [offsetWidth, setOffsetWidth] = useState(0)
  const trackRef = useRef(null)
  const cardRef = useRef(null)
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const getVisibleCards = () => {
    const viewportWidth = window.innerWidth
    if (viewportWidth < 768) {
      return 1
    } else if (viewportWidth < 1024) {
      return 2
    } else {
      return 3
    }
  }

  const handleNext = () => {
    console.log("handleNext");
    console.log(isNextDisabled , "isNextDisabled");
   if (isNextDisabled) return; // prevent spam click

      setIsNextDisabled(true);
      setCurrentIndex(prevIndex => prevIndex + 1);

      // Re-enable after a short delay (match your slide transition duration)
      setTimeout(() => {
        setIsNextDisabled(false);
      }, 350); // Adjust timing as needed
};

  const handlePrev =  () => {
 if (isNextDisabled) return; // prevent spam click

      setIsNextDisabled(true);
     setCurrentIndex(currentIndex - 1) 

      // Re-enable after a short delay (match your slide transition duration)
       setTimeout(() => {
        setIsNextDisabled(false);
      }, 350); // Adjust timing as needed 

    


  };

  const handleDotClick = (index) => {
    setCurrentIndex(index + cloneCount)
  }

  const flexStyle = {
    flex: `0 0 calc(${cardFlex}px)`,
       boxSizing: "border-box"
    //  width: `${cardFlex - 20}px`,
  }

   // Custom styles based on settings
  const customStyles = {
    txtColor: {
      color: settings?.text_color,
    },
    titleColor: {
      color: settings?.title_color,
    },
    navBtnPrv: {
      color: settings?.color_prev,
    },
    navBtnNxt: {
      color: settings?.color_next,
    },
    navBtnNxtBg: {
      backgroundColor: settings?.color_next ,
    },
    navBtnPrevBg: {
      backgroundColor: settings?.color_prev ,
    },
    dot: {
      backgroundColor:  settings?.dot_color,
    
    },
    showDot: {
        display: settings?.show_dots ? "" : "none",
    },
    activeDot: {
      backgroundColor: settings?.dot_color,
    },
    card: {
      backgroundColor: settings?.card_bg,
    },
    starStyle: {
      color: settings?.star_color,
      display: settings?.show_stars ? "" : "none",
    },
  }

  const trackStyle = {
    transform: `translateX(${-currentIndex * (cardWidth + (20)) + 10}px)`,
    transition: isTransitioning ? "transform 0.5s ease" : "none",
    gap: "20px"
  }
//  transform: `translateX(${-currentIndex * (cardFlex * cloneCount + (20 * cloneCount) )}px)`,
  // Calculate which dot should be active
  const activeDotIndex = (() => {
    if (currentIndex + 1 <= cloneCount) {
      return testimonials.length - (cloneCount - currentIndex)
    } else if (currentIndex >= testimonials.length + cloneCount) {
      return currentIndex - testimonials.length - cloneCount
    } else {
      return currentIndex - cloneCount
    }
  })()

  
  const handleTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].clientX;
  };
  
  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    handleSwipe();
  };

  const handleSwipe = () => {
    const diff = touchStartX.current - touchEndX.current;
  
    if (Math.abs(diff) > 50) { // minimum swipe threshold
      if (diff > 0) {
        handleNext(); // swipe left
      } else {
        handlePrev(); // swipe right
      }
    }
  };

  
  useEffect(() => {
    if (trackRef.current) {
      const trackWidth = trackRef.current.offsetWidth
     
      const width = window.innerWidth;

      if(Math.abs(trackWidth - cardRef.current.offsetWidth * cloneCount) > 351 && width >= 361){
        setOffsetWidth(65);
      }else{
        setOffsetWidth(26);
      }
    }


      if(settings.auto_slide){
        
          const slideInterval = setInterval(() => {
              handleNext();
            }, 3000 );

            return () => clearInterval(slideInterval); // Cleanup on unmount
      }
  } , [])
  useEffect(() => {
    if (cardRef.current) {
      const computedStyle = window.getComputedStyle(cardRef.current)
      setCardWidth(cardRef.current.offsetWidth )
      setCardMargin(Number.parseInt(computedStyle.marginRight)  + Number.parseInt(computedStyle.marginLeft) )
    }

    if (trackRef.current) {
      const trackWidth = trackRef.current.offsetWidth

      // console.log(trackWidth);
      // && testimonials.length <= 3
      if(settings?.max_per_dot !== null ){

        const gap = 20; // px
        var columns = settings?.max_per_dot;
        var totalGapWidth = (columns - 1) * gap;
        var cardWidth = (trackWidth - totalGapWidth) / columns;
        var cardWidthFormula = ((((cardWidth + gap) * columns) - 20) / columns ) - 20;
        
       
       

      
         console.log(trackWidth, "trackWidth");

        if (trackWidth <= 1259 && trackWidth >= 1104 && columns > 7) {
              columns = 7;
          }
          else if (trackWidth <= 1103 && trackWidth >= 1049  && columns > 6) {
              columns = 6;
          }else if (trackWidth <= 1048 && trackWidth >= 788 && columns > 5) {
              columns = 5;
          }else if (trackWidth <= 787  && trackWidth >= 630 && columns > 4) {
              columns = 4;
          }else if (trackWidth <= 629  && trackWidth >= 470 && columns > 3) {
              columns = 3;
          }else if (trackWidth <= 469  && trackWidth >= 344 && columns > 2) {
              columns = 2;
          }else if (trackWidth <= 343  && trackWidth >= 0 && columns > 1) {
              columns = 1;
          }

          // Now calculate based on final columns
          totalGapWidth = (columns - 1) * gap;
          cardWidth = (trackWidth - totalGapWidth) / columns;
          cardWidthFormula = ((((cardWidth + gap) * columns) - 20) / columns ) - 20;
        
          setCardFlex(cardWidthFormula);


       /*  if(settings?.max_per_dot === 1){
           setCardFlex(cardWidth - spaceAdjust); 
        }else{
         
            setCardFlex(cardWidth - spaceAdjust ); 
        } */

       /* 
       Old formula
       var percent = 1.333;
        
        if (trackWidth >= 729 ) {
             percent = 1.333;
        }
        else if (trackWidth <= 728 && trackWidth >= 605  ) {
           percent = 1.8;
        }
        else if (trackWidth <= 604 && trackWidth >= 370   ) {
           percent = 2.3;
        }
        else if (trackWidth <= 369 && trackWidth >= 300  ) {
           percent = 3.4;
        }
         else if (trackWidth <= 299 && trackWidth >= 100  ) {
           percent = 6.5;
        }


        const spaceAdjust = (percent / 100) * cardWidth;
       setCardFlex(cardWidth - spaceAdjust ); 
 setCardFlex(((((cardWidth + gap) * columns) - 20) / columns ) - 20);  */


        //  const cardWidth = (trackWidth * (100  /  settings?.max_per_dot)) / 100;


          // console.log(totalGapWidth , "totalGapWidth");
       


          // console.log((trackWidth  - columns ) - ((cardWidth * columns ) + gap)   , "(cardWidth - gap) * columns ");
        //  setCardFlex(cardWidth); 

      }


       /* if (trackWidth >= 1426) {
          setCardFlex(15.36); 
       }
       else if (trackWidth <= 1425 && trackWidth >= 1240  ) {
            setCardFlex(18.5); 
       }
       else if (trackWidth <= 1239 && trackWidth >= 951  ) {
            if(trackWidth <= 950 ){
              setCardFlex(23);
            }
            else if(trackWidth <= 999 ){
              setCardFlex(23.1);
            }
            else if(trackWidth <= 1027 ){
              setCardFlex(23.2);
            }
            else if(trackWidth <= 1185 ){
              setCardFlex(23.3);
            }else{
              setCardFlex(23.5); 
            }
            
       }
       else if (trackWidth <= 950 && trackWidth >= 700  ) {
            if(trackWidth <= 740){
              setCardFlex(30.833);
            }
            else if(trackWidth <=  760){
              setCardFlex(31);
            }
            else if(trackWidth <=  798){
              setCardFlex(31.033);
            }
            else if(trackWidth <=  829){
              setCardFlex(31.133);
            }
            else if(trackWidth <= 885){
              setCardFlex(31.233);
            }else{
              setCardFlex(31.333); 
            }
        }  else if (trackWidth <= 699 && trackWidth >= 455  ) {
            if(trackWidth <= 480){
               setCardFlex(46.5)
            }
            else if(trackWidth <= 550){
                setCardFlex(47)
            }
            else if(trackWidth <= 589){
               setCardFlex(47.3);
            }else{
               setCardFlex(47.5);
            }
            
        }else{
          if(trackWidth <= 253){
            setCardFlex(94);
          }
          else{
            setCardFlex(97);
           }
        } */
       
    }

   
    const handleResize = () => {
      if (cardRef.current) {
        const computedStyle = window.getComputedStyle(cardRef.current)
        setCardWidth(cardRef.current.offsetWidth)
        setCardMargin(Number.parseInt(computedStyle.marginRight)  + Number.parseInt(computedStyle.marginLeft) )
      }

      if (trackRef.current) {
        // console.log("fasdgas");
         const trackWidth = trackRef.current.offsetWidth
         if(settings?.max_per_dot !== null ){

              const gap = 20; // px
              var columns = settings?.max_per_dot;
              var totalGapWidth = (columns - 1) * gap;
              var cardWidth = (trackWidth - totalGapWidth) / columns;
              var cardWidthFormula = ((((cardWidth + gap) * columns) - 20) / columns ) - 20;
              
            
            

            
              console.log(trackWidth, "trackWidth");

              if (trackWidth <= 1259 && trackWidth >= 1104 && columns > 7) {
                    columns = 7;
                }
                else if (trackWidth <= 1103 && trackWidth >= 1049  && columns > 6) {
                    columns = 6;
                }else if (trackWidth <= 1048 && trackWidth >= 788 && columns > 5) {
                    columns = 5;
                }else if (trackWidth <= 787  && trackWidth >= 630 && columns > 4) {
                    columns = 4;
                }else if (trackWidth <= 629  && trackWidth >= 470 && columns > 3) {
                    columns = 3;
                }else if (trackWidth <= 469  && trackWidth >= 344 && columns > 2) {
                    columns = 2;
                }else if (trackWidth <= 343  && trackWidth >= 0 && columns > 1) {
                    columns = 1;
                }

                // Now calculate based on final columns
                totalGapWidth = (columns - 1) * gap;
                cardWidth = (trackWidth - totalGapWidth) / columns;
                cardWidthFormula = ((((cardWidth + gap) * columns) - 20) / columns ) - 20;
              
                setCardFlex(cardWidthFormula);


            /*  if(settings?.max_per_dot === 1){
                setCardFlex(cardWidth - spaceAdjust); 
              }else{
              
                  setCardFlex(cardWidth - spaceAdjust ); 
              } */

            /* 
            Old formula
            var percent = 1.333;
              
              if (trackWidth >= 729 ) {
                  percent = 1.333;
              }
              else if (trackWidth <= 728 && trackWidth >= 605  ) {
                percent = 1.8;
              }
              else if (trackWidth <= 604 && trackWidth >= 370   ) {
                percent = 2.3;
              }
              else if (trackWidth <= 369 && trackWidth >= 300  ) {
                percent = 3.4;
              }
              else if (trackWidth <= 299 && trackWidth >= 100  ) {
                percent = 6.5;
              }


              const spaceAdjust = (percent / 100) * cardWidth;
            setCardFlex(cardWidth - spaceAdjust ); 
      setCardFlex(((((cardWidth + gap) * columns) - 20) / columns ) - 20);  */


              //  const cardWidth = (trackWidth * (100  /  settings?.max_per_dot)) / 100;


                // console.log(totalGapWidth , "totalGapWidth");
            


                // console.log((trackWidth  - columns ) - ((cardWidth * columns ) + gap)   , "(cardWidth - gap) * columns ");
              //  setCardFlex(cardWidth); 

          
            }
      }
    }

    window.addEventListener("resize", handleResize)
      return () => window.removeEventListener("resize", handleResize)
    }, [trackStyle])


  // Handle the infinite scroll transition
  useEffect(() => {
    if (!isTransitioning) return

    const handleTransitionEnd = () => {
      // If we've scrolled to a clone, jump to the real item without transition
      console.log("sample")
      if (currentIndex <= cloneCount - 2) {
        setIsTransitioning(false)
        setCurrentIndex(testimonials.length + (currentIndex % testimonials.length))
      } else if (currentIndex >= testimonials.length + cloneCount) {
        setIsTransitioning(false)
        setCurrentIndex(currentIndex % testimonials.length || cloneCount)
      }
    }

    const trackElement = trackRef.current
    if (trackElement) {
      trackElement.addEventListener("transitionend", handleTransitionEnd)
      return () => {
        trackElement.removeEventListener("transitionend", handleTransitionEnd)
      }
    }
  }, [currentIndex, isTransitioning, testimonials.length])

  // Re-enable transitions after the position has been reset
  useEffect(() => {
    if (!isTransitioning) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsTransitioning(true)
        })
      })
    }
  }, [isTransitioning])

  return (
    <div className={styles.container} id={`woatestimonial_${settings.design}`}>  
	
     
      <div className={styles.testimonialSlider}>

        {(settings.design === "design1") &&   
          <button className={`${settings.design} ${styles.navBtn} ${styles.btnleft}`} onClick={handlePrev} aria-label="Previous testimonial">
            <span style={customStyles.navBtnPrv }  class="dashicons dashicons-arrow-left-alt2"></span>
          </button>
        }
        {(settings.design === "design3" ) &&   
         <button style={{"--setting-bg-next" : customStyles.navBtnPrevBg?.backgroundColor || "#164976"}} className={`${settings.design} ${styles.navBtn} ${styles.btnleft}`}onClick={handlePrev} aria-label="Previous testimonial">
                 <span style={customStyles.navBtnPrv }  class="dashicons dashicons-arrow-left-alt"></span>
            </button>
        }
    
        <div className={`${styles.testimonialWrapper} testimonialSlides`}>
          <div className={styles.testimonialTrack} ref={trackRef} style={trackStyle} onTouchStart={handleTouchStart}  onTouchEnd={handleTouchEnd}>
            {allTestimonials.map((testimonial, index) => (
              <div
                key={index}
                ref={index === cloneCount ? cardRef : null}
                className={`${styles.cardWrapper} woatestimonial-card`}
                style={{...flexStyle , ...customStyles.card} }
              >
                
                { settings.design === "design1" && <TestimonialCard CStyle={customStyles} testimonial={testimonial} />}
                { settings.design === "design2" && <TestimonialCardD2 CStyle={customStyles} testimonial={testimonial} />}
                { settings.design === "design3" && <TestimonialCardD3 CStyle={customStyles} testimonial={testimonial} />}
                
              </div>
            ))}
          </div>
        </div>

        {(settings.design === "design1" ) &&   
            <button  className={`${settings.design} ${styles.navBtn} ${styles.btnrigth}`} onClick={handleNext} aria-label="Next testimonial">
              <span style={customStyles.navBtnNxt } class="dashicons dashicons-arrow-right-alt2"></span>
          </button>
        }
      {(settings.design === "design2"  || settings.design === "design3" ) &&   
            <button style={{"--setting-bg-next" : customStyles.navBtnNxtBg?.backgroundColor || "#164976"}}  className={`${settings.design} ${styles.navBtn} ${styles.btnrigth}`}onClick={handleNext} aria-label="Next testimonial">
                 <span style={customStyles.navBtnNxt } class="dashicons dashicons-arrow-right-alt"></span>
            </button>
        }
    
     
      </div>

      <div  style={customStyles.showDot}  className={`${styles.dotsContainer} woadotslider`}>
        {testimonials.map((_, index) => (
          <span
            key={index}
            style={activeDotIndex === index ? customStyles.dot : {} }
            className={`${styles.dot} ${activeDotIndex === index ? styles.activeDot : ""}`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>
    </div>
  )
}
